import React, {useEffect} from 'react';

import ButtonComponentV2 from '../redesign/buttonComponentV2/buttonComponentV2';
import DropDownItem from './dropDownItem';

import './dropDownV2.css';

const DropDownV2 = ({
  showButtonUI = true,
  options = [],
  onClose = () => {},
  onItemSelected = () => {},
}) => {
  useEffect(() => {
    window.addEventListener('click', handleOutsideEvent);
    return () => {
      window.removeEventListener('click', handleOutsideEvent);
    };
  }, []);

  const handleOutsideEvent = (e) => {
    const dropDownContainerDiv = document.getElementById(
      'et-v2-drop-down-container-div',
    );
    if (!dropDownContainerDiv?.contains(e.target)) {
      onClose();
    }
  };

  return (
    <div
      id="et-v2-drop-down-container-div"
      className="et-v2-drop-down-container">
      {options.map(
        (
          {
            id,
            isSelected,
            isLineSeparator,
            showBoldText,
            LeftComponent,
            RightComponent,
            btnText,
          },
          idx,
        ) =>
          isLineSeparator ? (
            <div key={id ?? idx} className="et-v2-drop-drop-item-separator" />
          ) : (
            <div key={id} className="et-v2-drop-drop-item-wrap">
              {showButtonUI ? (
                <ButtonComponentV2
                  isSelected={isSelected}
                  Icon={LeftComponent}
                  btnText={btnText}
                  onClick={() => onItemSelected(id)}
                />
              ) : (
                <DropDownItem
                  isSelected={isSelected}
                  isLineSeparator={isLineSeparator}
                  showBoldText={showBoldText}
                  btnText={btnText}
                  LeftComponent={LeftComponent}
                  RightComponent={RightComponent}
                  onClick={() => onItemSelected(id)}
                />
              )}
            </div>
          ),
      )}
    </div>
  );
};

export default DropDownV2;
